import { render } from "./InicioView.vue?vue&type=template&id=5f438c42"
import script from "./InicioView.vue?vue&type=script&lang=js"
export * from "./InicioView.vue?vue&type=script&lang=js"

import "./InicioView.vue?vue&type=style&index=0&id=5f438c42&scope=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__